import { UserPermissions } from 'entities/user';
import { StatusLoading } from 'common/constants/statusLoading';
import { User } from './user';

import { TUserType } from './userType';

export const STATE = 'AUTH';

export interface IState {
  userType: TUserType;
  permissions: {
    loadingStatus?: StatusLoading;
    data?: UserPermissions;
  },
  user: {
    loadingStatus?: StatusLoading;
    data?: User;
  },
}